import React from 'react'
import { PropTypes } from 'prop-types'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'
import { graphqlCurrentUserCached } from 'lib/utils/store/currentUser'

import ActionLogic from 'components/Util/ActionLogic'

import uploadVehicleImage from 'graphql/vehicle/uploadVehicleImage.gql'
import uploadVehicleAttachment from 'graphql/vehicle/uploadVehicleAttachment.gql'
import uploadRekkariDocument from 'graphql/vehicle/uploadRekkariDocument.gql'
import getVehicleProfileView from 'graphql/view/getVehicleProfileView.gql'

export const FileUploadLogicContext = React.createContext()

class FileUploadLogic extends React.Component {
    uploadVehicleAttachment = async (actionLogic, vehicleId, file) => {
        return actionLogic.callMutation(this.props.uploadVehicleAttachment, {
            variables: {
                vehicleId: vehicleId,
                file: file,
            }
        })
    }

    uploadVehicleImage = async (actionLogic, vehicleId, file, cropData) => {
        const { currentUser, uploadVehicleImage } = this.props

        return actionLogic.callMutation(uploadVehicleImage, {
            variables: {
                vehicleId: vehicleId,
                file: file,
                cropData: cropData
            },
            refetchQueries: [{
                query: getVehicleProfileView,
                variables: {
                    vehicleId: vehicleId,
                    userId: currentUser.me.id,
                }
            }],
        })
    }

    uploadRekkariDocument = async (actionLogic, vehicleId, file) => {
        return actionLogic.callMutation(this.props.uploadRekkariDocument, {
            variables: {
                vehicleId: vehicleId,
                file: file,
            }
        })
    }

    getRenderProps = (actionLogic) => {
        return {
            ...actionLogic,
            uploadVehicleImage: (...args) => this.uploadVehicleImage(actionLogic, ...args),
            uploadVehicleAttachment: (...args) => this.uploadVehicleAttachment(actionLogic, ...args),
            uploadRekkariDocument: (...args) => this.uploadRekkariDocument(actionLogic, ...args),
        }
    }

    handleMount = (actionLogic) => {
        const { onMount } = this.props
        onMount && onMount(this.getRenderProps(actionLogic))
    }

    render () {
        const { children, initState } = this.props
        return (
            <ActionLogic initState={initState} onMount={this.handleMount}>
                {(actionLogic) => {
                    const props = this.getRenderProps(actionLogic)
                    return (
                        <FileUploadLogicContext.Provider value={props}>
                            {children(props)}
                        </FileUploadLogicContext.Provider>
                    )
                }}
            </ActionLogic>
        )
    }
}

FileUploadLogic.propTypes = {
    children: PropTypes.func.isRequired,
    onMount: PropTypes.func,
    initState: PropTypes.object,
}

export default flowRight(
    graphqlCurrentUserCached,
    graphql(uploadVehicleImage, {
        name: 'uploadVehicleImage'
    }),
    graphql(uploadVehicleAttachment, {
        name: 'uploadVehicleAttachment'
    }),
    graphql(uploadRekkariDocument, {
        name: 'uploadRekkariDocument'
    }),
)(FileUploadLogic)
